import React from 'react';

const Activity = ({viewUser,}) => {

  return (
    <div className="activity-comp">
      activity-comp
    </div>
  );

};

export default Activity;